import React                            from 'react';
import classNames                       from 'classnames';
import { Observe }                      from 'rewire-core';
import {
  WithStyle,
  FormView
}                                       from 'rewire-ui';
import { Theme }                        from '@material-ui/core/styles';
import DraggableResizableDialog         from '../ui/DraggableResizableDialog';
import reportSecondaryFilterDialogModel from './ReportSecondaryFilterDialogModel';
import { withStyles }                   from '../utility/styles';

const styles = (_theme: Theme) => ({
  selectMenuPaper: {
    minWidth: '175px !important',
  },
  placeholder: {
    '& input': {
      fontStyle: 'italic',
    },
    '& span > span': {
      fontStyle: 'italic',
    },
  },
  heading: {
    marginLeft: '10px',
    color: 'gray',
  },
});

interface IReportSecondaryFilterDialogProps {
}

type ReportSecondaryFilterDialogProps = WithStyle<ReturnType<typeof styles>, IReportSecondaryFilterDialogProps>;

class ReportSecondaryFilterDialog extends React.PureComponent<ReportSecondaryFilterDialogProps> {
  constructor(props: ReportSecondaryFilterDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    reportSecondaryFilterDialogModel.reset();
  }

  renderContents = React.memo((): JSX.Element | null => {
    const { classes }         = this.props;
    const fields              = reportSecondaryFilterDialogModel.form.fields;
    const hasPermittedFilters = reportSecondaryFilterDialogModel.hasPermittedFilters;

    return !hasPermittedFilters
      ? null
      : (
          <>
            {fields.map(field => {
              const Editor = field.Editor;
              return field.visible && <div className='content'><Editor className={classNames(classes.placeholder, 'span4')} /></div>;
            })}

          </>
        );
  });

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={reportSecondaryFilterDialogModel.form} onSubmit={reportSecondaryFilterDialogModel.actionFn('apply')}>
        <this.renderContents />
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='sm' DialogProps={{dialog: reportSecondaryFilterDialogModel, actions: ['cancel', 'apply']}} DraggableResizableBoxProps={{minWidth: '345px', minHeight: '480px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IReportSecondaryFilterDialogProps>(styles, ReportSecondaryFilterDialog);
